import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("rect", {
  width: "32",
  height: "32",
  rx: "7.12121",
  transform: "matrix(1 0 0 -1 0 32)",
  fill: "#6B4BCC"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M13.943 17.7988C14.9967 17.7988 15.8392 17.0348 15.8392 15.996C15.8392 14.9573 14.9967 14.1933 13.943 14.1933C12.9202 14.1933 12.0469 14.9573 12.0469 15.996C12.0469 17.0348 12.9202 17.7988 13.943 17.7988Z",
  fill: "white"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M20.958 17.2201V25.1461C20.958 25.9325 21.5541 26.5669 22.3284 26.5669C23.1335 26.5669 23.7297 25.9325 23.7297 25.1461V6.84348C23.7297 6.05713 23.1335 5.4227 22.3284 5.4227C21.5541 5.4227 20.958 6.05713 20.958 6.84348V17.2201Z",
  fill: "white"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", {
  d: "M11.0375 14.6474V6.842C11.0375 6.05566 10.4414 5.42122 9.63629 5.42122C8.86419 5.41899 8.26807 6.05566 8.26807 6.842V25.1446C8.26807 25.931 8.86419 26.5654 9.63849 26.5654C10.4436 26.5654 11.0397 25.931 11.0397 25.1446V14.6474H11.0375Z",
  fill: "white"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_6);
}
const uikitHorizLogoIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitHorizLogoIcon as default
};
//# sourceMappingURL=uikit-horiz-logo-icon.vue.es.js.map
